import React from 'react'
import fastLoading from '../assets/fastLoading.gif'
const PageNotFound = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(256, 256, 256, 0.1)',
            padding: '10px',
            borderRadius: '20px',
            backgroundImage: `url(${fastLoading})`,
            width: '80%',
            objectFit: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            margin: 'auto',
        }} >
            <div style={Window.innerWidth > 350 ? {
                color: 'rgb(0,67,77)',
                fontSize: '30px',
                fontWeight: 'bold',
                letterSpacing: '3px',
                display: "block",
                marginTop: '370px',
                zIndex: '1',
            } : {
                color: 'rgb(0,67,77)',
                fontSize: '20px',
                fontWeight: 'bold',
                letterSpacing: '3px',
                display: "block",
                marginTop: '370px',
                zIndex: '1',
            }}>Page Under Contraction</div>
        </div>
    );
}
 
export default PageNotFound